import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Banner_1 from '../../../assets/images/home_page_5/banner/01.png'
import Banner_2 from '../../../assets/images/home_page_5/banner/02.png'

const Bannerfive = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,

}

const Banner = () => {
    return (
        <>
            <section id="home-five-banner" className="home-five-banner-main-block">
                <div className="container">
                    <div className="home-five-banner-block">
                        <div className="row">
                            <div className="col-lg-6">
                                <Slider className="slider home-five-nav-autoplay" {...Bannerfive}>
                                    <div className="home-five-banner-dtl">
                                        <h6 className="home-five-sub-title">
                                            Exclusive Offer{" "}
                                            <span className="badge text-bg-primary">-20%Off</span>
                                        </h6>
                                        <h1 className="home-five-title">Super fast performance</h1>
                                        <p>
                                            We have prepared special discounts for you on electronic
                                            products. Don't miss these opportunities...
                                        </p>
                                        <Link to="#" title="" className="btn btn-primary-five">
                                            {" "}
                                            Shop now <i className="flaticon-right-arrow" />
                                        </Link>
                                    </div>
                                    <div className="home-five-banner-dtl">
                                        <h6 className="home-five-sub-title">
                                            Exclusive Offer{" "}
                                            <span className="badge text-bg-primary">-20%Off</span>
                                        </h6>
                                        <h1 className="home-five-title">Super fast performance</h1>
                                        <p>
                                            We have prepared special discounts for you on electronic
                                            products. Don't miss these opportunities...
                                        </p>
                                        <Link to="#" title="" className="btn btn-primary-five">
                                            {" "}
                                            Shop now <i className="flaticon-right-arrow" />
                                        </Link>
                                    </div>
                                </Slider>
                            </div>
                            <div className="col-lg-6">
                                <Slider className="slider home-five-for-autoplay" {...Bannerfive}>
                                    <div className="home-five-img-block">
                                        <div className="home-five-border-one" />
                                        <img
                                            src={Banner_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                        <div className="home-five-border-two" />
                                    </div>
                                    <div className="home-five-img-block">
                                        <div className="home-five-border-one" />
                                        <img
                                            src={Banner_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                        <div className="home-five-border-two" />
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Banner
